const INGREDIENT_SPECIAL_CASES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default INGREDIENT_SPECIAL_CASES_INITIAL_STATE
